import translation from 'locales/translation';
/* eslint-disable react-hooks/exhaustive-deps */
import { EventBigCard } from 'components/__ASSOCIADO__/Associado/EventBigCard/EventBigCard';
import VideoPlayer from 'components/__ASSOCIADO__/Associado/VideoPlayer';
import BlocoMinhasAssembleias from 'components/__ASSOCIADO__/BlocoMinhasAssembleias/BlocoMinhasAssembleias';
import { AssembleiaIcon } from 'components/Icons';
import Loading from 'components/Modal/__LEGACY__/AbrirVotacaoPautaModal/Loading';
import { DateFormats } from 'helpers/enums/DateTypes';
import ErrorHandler from 'helpers/utils/ErrorHandler';
import { clsx } from 'helpers/utils/HTMLUtils';
import { AssociadoRoutePath } from 'library/Routes';
import { StateCode } from 'library/states';
import {
  Button,
  ButtonThemes,
  Col,
  Collapse,
  Row,
} from 'plataforma-fundacao-componentes';
import React, {
  useCallback,
  useEffect,
  useMemo,
  useReducer,
  useState,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { scroller } from 'react-scroll';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { IEventosPorAssociado } from 'store/modules/AssembleiasAssociadoReducer';
import { associadoActionCarregarParametros } from 'store/modules/associado/actions';
import { IReducer } from 'store/Reducer';
import { history } from 'store/Store';
import styles from './HomeAssociado.scss';
import { parametrosAssociadoInitialState, parametrosReducer } from './reducer';

const rootClassName = styles.rootClassName;

const URL_VID = 'https://www.youtube.com/watch?v=ipnhX7gfsQs';

export default function Home() {
  const [verMais, setVerMais] = useState(false);
  const [verMaisREU, setVerMaisREU] = useState(false);
  const dispatch = useDispatch();
  const { all, loadingAll } = useSelector(
    (state: IReducer) => state.assembleias
  );
  const { parametros, parametrosIsLoading } = useSelector(
    (state: IReducer) => state.associado
  );
  const [state, action] = useReducer(
    parametrosReducer,
    parametrosAssociadoInitialState
  );

  const HasEventosConvocado = useMemo(() => {
    if (!state.listaEvento || !state.listaEvento.length) return false;
    return state.listaEvento.some(
      (item) => item.tipoEvento !== 'Reunião' && item.flgConvocado
    );
  }, [state]);

  const HasEventosNaoConvocado = useMemo(() => {
    if (!state.listaEvento || !state.listaEvento.length) return false;
    return state.listaEvento.some((item) => !item.flgConvocado);
  }, [state]);

  const HasEventosReu = useMemo(() => {
    if (!state.listaEvento || !state.listaEvento.length) return false;

    return state.listaEvento.some(
      (item) => item.tipoEvento === 'Reunião' && item.flgConvocado
    );
  }, [state]);

  const getTextoVideo = useCallback(() => {
    if (!parametros && !parametrosIsLoading) {
      dispatch(associadoActionCarregarParametros(undefined, ErrorHandler));
    }
  }, [dispatch, parametros, parametrosIsLoading]);

  useEffect(() => {
    getTextoVideo();
  }, []);

  useEffect(() => {
    action({
      type: 'setListaEvento',
      value: all,
    });
  }, [all]);

  useEffect(() => {
    const idAssembleiaSession: string | null =
      sessionStorage.getItem('assembleia_id');
    if (state.listaEvento.length && idAssembleiaSession) {
      sessionStorage.removeItem('assembleia_id');
      if (
        state.listaEvento.some(
          (assembleia) => String(assembleia.idEvento) === idAssembleiaSession
        )
      ) {
        history.push(
          `${AssociadoRoutePath}/assembleia/${idAssembleiaSession}/`
        );
      }
    }
  }, [JSON.stringify(state.listaEvento)]);

  return (
    <article
      style={{
        maxHeight: '100vh',
        overflow: 'auto',
      }}
      id='root-container-home'
    >
      <div className={rootClassName}>
        <div className={`${rootClassName}-left`}>
          <Row>
            <Col
              cols={[12, 12, 12, 12, 12]}
              className={`${rootClassName}-title`}
              data-testid={'home-associado-page-title'}
            >
              {translation.TelaInicialAssociado.title}
            </Col>
          </Row>
          <Row>
            <Col className={`${rootClassName}-bloco-minhas-assembleias`}>
              {loadingAll ? (
                <Loading estatico backgroundTransparent />
              ) : (
                <BlocoMinhasAssembleias
                  title={
                    translation.TelaInicialAssociado.blocoMinhasAssembleias
                      .title
                  }
                  linked={
                    translation.TelaInicialAssociado.blocoMinhasAssembleias.link
                  }
                  subtitle={
                    translation.TelaInicialAssociado.blocoMinhasAssembleias
                      .message
                  }
                  onClick={() => {
                    if (state.listaEvento.length === 1) {
                      history.push(
                        `${AssociadoRoutePath}/assembleia/${state.listaEvento[0].idEvento}/`
                      );
                    } else if (HasEventosConvocado) {
                      scroller.scrollTo('assembleias-associado', {
                        containerId: 'root-container-home',
                        duration: 300,
                        delay: 0,
                        smooth: 'easeInOutQuart',
                        offset: -52,
                      });
                    } else if (HasEventosNaoConvocado) {
                      scroller.scrollTo('assembleias-associado', {
                        containerId: 'root-container-home',
                        duration: 300,
                        delay: 0,
                        smooth: 'easeInOutQuart',
                        offset: -52,
                      });
                    }
                  }}
                  notFound={
                    translation.TelaInicialAssociado.blocoMinhasAssembleias
                      .notFound
                  }
                  showNotFound={
                    !Boolean(HasEventosConvocado || HasEventosNaoConvocado)
                  }
                />
              )}
            </Col>
          </Row>
          <Row>
            <Col
              cols={[12, 12, 12, 12, 12]}
              className={`${rootClassName}-video`}
            >
              <VideoPlayer
                url={parametros?.urlVideo || URL_VID}
                blockRedirect={true}
              />
            </Col>
          </Row>
          <Row>
            <Col
              cols={[12, 12, 12, 12, 12]}
              className={`${rootClassName}-texto nunito`}
              data-testid={'home-associado-page-texto'}
            >
              {parametros?.texto}
            </Col>
          </Row>
        </div>
        <div
          id='assembleias-associado'
          className={clsx([
            `${rootClassName}-right`,
            !HasEventosConvocado && !HasEventosNaoConvocado && !HasEventosReu
              ? `${rootClassName}-disappear-on-mobile`
              : '',
          ])}
        >
          <Row>
            <Col className={`${rootClassName}-icon-assembleias`}>
              <AssembleiaIcon />
            </Col>
          </Row>
          <Row
            className={`${rootClassName}-minhas-assembleias-title`}
            data-testid={'home-associado-page-minhas-assembleias-title'}
          >
            <Col>
              {translation.TelaInicialAssociado.blocoMinhasAssembleias.title}
            </Col>
          </Row>
          {HasEventosConvocado || HasEventosNaoConvocado ? (
            <React.Fragment>
              <Row>
                <Col
                  className={`${rootClassName}-minhas-assembleias-sub-title`}
                  data-testid={
                    'home-associado-page-minhas-assembleias-sub-title'
                  }
                >
                  {
                    translation.TelaInicialAssociado.blocoMinhasAssembleias
                      .subtitle
                  }
                </Col>
              </Row>
              <hr />
              <Row>
                <Col
                  className={`${rootClassName}-minhas-assembleias-asterisco`}
                  data-testid={
                    'home-associado-page-minhas-assembleias-asterisco'
                  }
                >
                  {translation.TelaInicialAssociado.asterisco}
                </Col>
              </Row>
              <Row>
                <Col
                  className={`${rootClassName}-minhas-assembleias-mobile-title`}
                >
                  {translation.TelaInicialAssociado.assembleias.convocado}
                </Col>
              </Row>
            </React.Fragment>
          ) : undefined}
          <Row className={`${rootClassName}-assembleias`}>
            {loadingAll && !state.listaEvento.length ? (
              <Row className={`${rootClassName}-loader`}>
                <Col centralized>
                  <Loading estatico backgroundTransparent />
                </Col>
              </Row>
            ) : undefined}
            <TransitionGroup className={`${rootClassName}-convocado`}>
              {state.listaEvento
                .filter(
                  (evento) =>
                    evento.tipoEvento !== 'Reunião' && evento.flgConvocado
                )
                .map((evento: IEventosPorAssociado, index: number) => {
                  return (
                    <CSSTransition
                      key={evento.idEvento}
                      timeout={700}
                      classNames='bloco-assembleia'
                    >
                      <div
                        className='bloco-assembleia'
                        data-testid={`card-assembleia-${index + 1}`}
                      >
                        <EventBigCard
                          eventId={evento.idEvento.toString()}
                          coopName={evento.nomeCoop}
                          eventType={evento.tipoEvento}
                          title={evento.tituloEvento}
                          eventDate={
                            evento.dataEvento as DateFormats.ISODateTwoDots
                          }
                          eventEndDate={
                            evento.dataFimEvento as DateFormats.ISODateTwoDots
                          }
                          eventDatePresential={
                            evento.dataEventoPresencial as DateFormats.ISODateTwoDots
                          }
                          eventEndDatePresential={
                            evento.dataFimEventoPresencial as DateFormats.ISODateTwoDots
                          }
                          situation={evento.situacao}
                          onlineSituation={evento.situacaoOnlineEvento}
                          cep={evento.cep}
                          address={evento.endereco}
                          neighborhood={evento.bairro}
                          city={evento.cidade}
                          state={evento.estado as StateCode}
                          modality={evento.modalidade}
                        />
                      </div>
                    </CSSTransition>
                  );
                })}
            </TransitionGroup>
            {HasEventosReu ? (
              <React.Fragment>
                <div className={`${rootClassName}-divider-top`} />
                <Row
                  className={`${rootClassName}-minhas-assembleias-semi-bold`}
                >
                  <Col className={`${rootClassName}-ver-mais-col reu`}>
                    <div>
                      {translation.TelaInicialAssociado.assembleias.reuniao}
                      <span>
                        {
                          translation.TelaInicialAssociado.assembleias
                            .acessereuniao
                        }
                      </span>
                    </div>
                    <Button
                      className={`${rootClassName}-ver-mais-btn`}
                      theme={ButtonThemes.DefaultPrimary}
                      onClick={() => setVerMaisREU(!verMaisREU)}
                    >
                      {
                        translation.TelaInicialAssociado.assembleias
                          .buttonToggleConvocado[`${verMaisREU}`]
                      }
                    </Button>
                  </Col>
                </Row>
                <Collapse opened={verMaisREU} animateOpacity>
                  {state.listaEvento
                    .filter(
                      (evento) =>
                        evento.tipoEvento === 'Reunião' && evento.flgConvocado
                    )
                    .map((evento: IEventosPorAssociado, key: number) => (
                      <div
                        key={key}
                        data-testid={`card-assembleia-collapse-${key + 1}`}
                        id={evento.idEvento.toString()}
                        className={'bloco-assembleia'}
                      >
                        <EventBigCard
                          eventId={evento.idEvento.toString()}
                          coopName={evento.nomeCoop}
                          eventType={evento.tipoEvento}
                          title={evento.tituloEvento}
                          eventDate={
                            evento.dataEvento as DateFormats.ISODateTwoDots
                          }
                          eventEndDate={
                            evento.dataFimEvento as DateFormats.ISODateTwoDots
                          }
                          eventDatePresential={
                            evento.dataEventoPresencial as DateFormats.ISODateTwoDots
                          }
                          eventEndDatePresential={
                            evento.dataFimEventoPresencial as DateFormats.ISODateTwoDots
                          }
                          situation={evento.situacao}
                          onlineSituation={evento.situacaoOnlineEvento}
                          cep={evento.cep}
                          address={evento.endereco}
                          neighborhood={evento.bairro}
                          city={evento.cidade}
                          state={evento.estado as StateCode}
                          modality={evento.modalidade}
                        />
                      </div>
                    ))}
                </Collapse>
                <div className={`${rootClassName}-divider`} />
              </React.Fragment>
            ) : undefined}
            {HasEventosNaoConvocado ? (
              <React.Fragment>
                <Row
                  className={`${rootClassName}-minhas-assembleias-semi-bold`}
                >
                  <Col className={`${rootClassName}-ver-mais-col`}>
                    <div>
                      {translation.TelaInicialAssociado.assembleias.convidado}
                      <span>
                        {
                          translation.TelaInicialAssociado.assembleias
                            .convidadoDesc
                        }
                      </span>
                    </div>
                    <Button
                      className={`${rootClassName}-ver-mais-btn`}
                      theme={ButtonThemes.DefaultPrimary}
                      onClick={() => setVerMais(!verMais)}
                    >
                      {
                        translation.TelaInicialAssociado.assembleias
                          .buttonToggleConvocado[`${verMais}`]
                      }
                    </Button>
                  </Col>
                </Row>
                <Collapse opened={verMais} animateOpacity>
                  {state.listaEvento
                    .filter((evento) => !evento.flgConvocado)
                    .map((evento: IEventosPorAssociado, key: number) => (
                      <div
                        key={key}
                        data-testid={`card-assembleia-collapse-${key + 1}`}
                        id={evento.idEvento.toString()}
                        className={'bloco-assembleia'}
                      >
                        <EventBigCard
                          eventId={evento.idEvento.toString()}
                          coopName={evento.nomeCoop}
                          eventType={evento.tipoEvento}
                          title={evento.tituloEvento}
                          eventDate={
                            evento.dataEvento as DateFormats.ISODateTwoDots
                          }
                          eventEndDate={
                            evento.dataFimEvento as DateFormats.ISODateTwoDots
                          }
                          eventDatePresential={
                            evento.dataEventoPresencial as DateFormats.ISODateTwoDots
                          }
                          eventEndDatePresential={
                            evento.dataFimEventoPresencial as DateFormats.ISODateTwoDots
                          }
                          situation={evento.situacao}
                          onlineSituation={evento.situacaoOnlineEvento}
                          cep={evento.cep}
                          address={evento.endereco}
                          neighborhood={evento.bairro}
                          city={evento.cidade}
                          state={evento.estado as StateCode}
                          modality={evento.modalidade}
                        />
                      </div>
                    ))}
                </Collapse>
              </React.Fragment>
            ) : undefined}
            {!loadingAll && !HasEventosNaoConvocado && !HasEventosConvocado ? (
              <Row>
                <Col
                  className={`${rootClassName}-not-found`}
                  data-testid={'home-associado-page-not-found'}
                >
                  {
                    translation.TelaInicialAssociado.blocoMinhasAssembleias
                      .notFound
                  }
                </Col>
              </Row>
            ) : undefined}
          </Row>
        </div>
      </div>
    </article>
  );
}
